import { createUseStyles } from "react-jss";
import {
    resolveChoiceIconGapModern,
    resolveChoiceLabelFontWeight,
    useModernChoiceStyles,
} from "../../../theme/choiceThemeTokens";
import type { Theme } from "../../../types/Theme";

export type ChoiceLabelStyleProps = {
    theme: Theme;
    fontWeight?: number;
};

export default createUseStyles({
    choiceText: {
        composes: "choice__text",
        fontWeight: ({ theme, fontWeight }: ChoiceLabelStyleProps) => {
            if (fontWeight !== undefined) {
                return fontWeight;
            }
            if (useModernChoiceStyles(theme)) {
                return resolveChoiceLabelFontWeight(theme);
            }
            return "bolder";
        },
        flex: 1,
    },
    spacer: {
        composes: "spacer",
        width: ({ theme }: { theme: Theme }) =>
            useModernChoiceStyles(theme) ? resolveChoiceIconGapModern(theme) : 20,
        flex: ({ theme }: { theme: Theme }) => theme.DisplayChoiceIcon === "right" && 1,
    },
});
